



























	import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
    import { store, CDR, StoreState } from '../store';
    import VueElementLoading from 'vue-element-loading';
    import {RotateSquare2} from 'vue-loading-spinner';
    import { mapState } from 'vuex';
    import util from '../lib/util';

	@Component({
        components: {
            RotateSquare2,VueElementLoading
		},
		computed: {
			...mapState({
                'devices': (state: StoreState) => (state.account as any).devices,
			})
		}
    })
	export default class QuickCall extends Vue {
        @Prop()
        public number_to_call!: string;

        data() {
            return {
                is_loading: false,
                selectedDevice: null,
            }
        }

        get registeredDevices() {
            return (this as any).devices.filter(e => {
                return e.registered;
            })
        }

        @Watch('registeredDevices')
        onRegisteredDevicesChange() {
            if ((this as any).registeredDevices.length > 0) {
                this.$data.selectedDevice = (this as any).registeredDevices[0].id;
            }
        }

        get formattedPhoneNumber() {
            return util.formatPhoneNumber(this.$props.number_to_call);
        }

        async created() {
             this.$data.is_loading = true;
            await this.$store.dispatch('getDevices');
            this.$data.is_loading = false;
        }

        cancel() {
            this.$store.commit('CLOSE_QUICK_CALL');
        }

        async quickCall() {
            await this.$store.dispatch("quickCall", {
                device: this.$data.selectedDevice,
                phone_number: this.$props.number_to_call
            });
            this.$store.commit('CLOSE_QUICK_CALL');
        }
	}
